import { MemberTaskFeedItem, MemberTaskFeedItemTypes } from '../types';

import isFrameworkTask from './isFrameworkTask';

/** Groups are always framework-native; tasks must be framework-migrated (have a location). */
export function isFrameworkMemberTaskFeedItem(item: MemberTaskFeedItem): boolean {
    return item.item_type === MemberTaskFeedItemTypes.GROUP || isFrameworkTask(item.task);
}

/** The location(s) an item surfaces on — used by the location filter on the Tasks page/carousel. */
export function memberTaskFeedItemLocations(item: MemberTaskFeedItem): string[] {
    return item.item_type === MemberTaskFeedItemTypes.GROUP
        ? item.group.group_template.location
        : item.task.task_template.location;
}

/** A feed item's product area, for the Tasks-page area filter. */
export function memberTaskFeedItemArea(item: MemberTaskFeedItem): string {
    return item.item_type === MemberTaskFeedItemTypes.GROUP ? item.group.group_template.area : item.task.effective_area;
}

/** Stable React key, namespaced by type so a group and task can't collide on id. */
export function memberTaskFeedItemKey(item: MemberTaskFeedItem): string {
    return item.item_type === MemberTaskFeedItemTypes.GROUP ? `group-${item.group.id}` : `task-${item.task.id}`;
}

/**
 * Whether a feed item is the Tasks-page deep-link target (to scroll + flash + open). A group matches on
 * `groupId`; a top-level task matches on `taskId` only when no `groupId` is present — a grouped task
 * lives in its group's panel, not the flat list, so `groupId` + `taskId` resolves to the group here and
 * opens its panel (we don't flash the individual task inside — see useGroupAction).
 */
export function isMemberTaskFeedItemDeepLinkTarget(
    item: MemberTaskFeedItem,
    deepLink: { taskId?: string; groupId?: string }
): boolean {
    const { taskId, groupId } = deepLink;
    if (item.item_type === MemberTaskFeedItemTypes.GROUP) {
        return groupId != null && item.group.id === groupId;
    }
    return groupId == null && taskId != null && item.task.id === taskId;
}
